import axios from 'axios';

export default function getHtmlVersion() {
  return new Promise((resolve, reject) => {
    axios
      .get('/')
      .then(({ data }) => {
        const parser = new DOMParser();
        const parsedDoc = parser.parseFromString(data, 'text/html');
        const element = parsedDoc.querySelector('meta[name="version"]');
        if (element && element.content) {
          resolve(element.content);
        } else {
          reject(new Error('Version unavailable'));
        }
      })
      .catch(reject);
  });
}
